import { createReducer, deleteIn, isMatchId, updateIn } from '../helpers';
import { api } from '../actions';

const setIsFetching = (bool) => (state) => {
    state.isFetching = bool;
};

const initialState = {
    items: [],
    guid: 0,
    isFetching: false,
};

export default createReducer(initialState, {
    [api.pageTemplates.create.request]: setIsFetching(true),
    [api.pageTemplates.retrieve.request]: setIsFetching(true),
    [api.pageTemplates.update.request]: setIsFetching(true),
    [api.pageTemplates.delete.request]: setIsFetching(true),
    [api.pageTemplates.create.failure]: setIsFetching(false),
    [api.pageTemplates.update.failure]: setIsFetching(false),
    [api.pageTemplates.delete.failure]: setIsFetching(false),
    [api.pageTemplates.list.failure]: setIsFetching(false),

    [api.pageTemplates.create.success]: (state, action) => {
        state.items.unshift(action.result);
        state.isFetching = false;
    },
    [api.pageTemplates.retrieve.success]: (state, action) => {
        if (!updateIn(state.items, isMatchId(action.templateId), action.result)) {
            state.items.unshift(action.result);
        }

        state.isFetching = false;
    },
    [api.pageTemplates.update.success]: (state, action) => {
        updateIn(state.items, isMatchId(action.templateId), action.result);

        state.isFetching = false;
    },
    [api.pageTemplates.delete.success]: (state, action) => {
        deleteIn(state.items, isMatchId(action.templateId));
        state.isFetching = false;
    },
    [api.pageTemplates.list.request]: (state) => {
        state.isFetching = true;
    },
    [api.pageTemplates.list.success]: (state, action) => {
        if (action.guid && action.guid < state.guid) {
            return state;
        }

        state.items = action.result;
        state.isFetching = false;
    },
});
